export default {
  checkout: {
    title: "Abonnement auswählen",
    subtitle: "Wählen Sie einen Tarif, um Lewara zu nutzen.",
    locked_title: "Abonnement aktivieren",
    locked_subtitle: "Wählen Sie einen Tarif, um Ihren Lewara-Arbeitsbereich freizuschalten. In einer Minute erledigt.",
    pay_title: "Bestätigen & bezahlen",
    pay_subtitle: "Überprüfen Sie Ihren Tarif und geben Sie Ihre Zahlungsdaten ein.",
    change_plan: "Tarif ändern",
    logout: "Abmelden",
    eyebrow: "Kasse",
    step_plan: "Tarif wählen",
    step_payment: "Zahlung",
    preparing: "Sichere Kasse wird vorbereitet …",
    secure_note: "Zahlungen werden sicher über Stripe abgewickelt.",
    mock_card_label: "Karteninformationen",
    mock_note: "Testmodus: es wird keine echte Zahlung verarbeitet.",
  },
  // Was ein Nutzer ohne MANAGE_BILLING anstelle der Kasse sieht. Die Texte sprechen bewusst über die
  // Berechtigung und nicht über den Abo-Status: ohne VIEW_BILLING kennt die Seite den Status gar nicht.
  noAccess: {
    eyebrow: "Abonnement",
    title: "Keine Berechtigung zur Abrechnung",
    subtitle: "Das Abonnement dieses Arbeitsbereichs kann nur von berechtigten Personen verwaltet werden.",
    // Paywall: der Arbeitsbereich ist gesperrt, bis jemand abschließt.
    paywall_contacts:
      "Sie können hier nichts abschließen. Wenden Sie sich an eine dieser Personen, um den Arbeitsbereich freizuschalten.",
    paywall_generic:
      "Sie können hier nichts abschließen. Wenden Sie sich an Ihren Administrator, um den Arbeitsbereich freizuschalten.",
    // Verwaltung: der Arbeitsbereich läuft, nur diese Änderung ist nicht erlaubt.
    manage_contacts:
      "Sie können das Abonnement nicht ändern. Wenden Sie sich an eine dieser Personen, wenn etwas angepasst werden soll.",
    manage_generic:
      "Sie können das Abonnement nicht ändern. Wenden Sie sich an Ihren Administrator, wenn etwas angepasst werden soll.",
  },
  plan: {
    basic: "Basic",
    pro: "Pro",
    enterprise: "Enterprise",
    recommended: "Beliebtester Tarif",
    includes: "Enthaltene Funktionen",
    basic_tagline: "Alles für einen gelungenen Start.",
    pro_tagline: "Für wachsende Teams mit mehr Bedarf.",
    enterprise_tagline: "Höchste Anforderungen und volle Kontrolle.",
  },
  featureSet: {
    core: "Kunden, Mitarbeiter, Maschinen & Material verwalten",
    project_management: "Projektverwaltung",
    invoicing: "Abrechnung",
    reporting: "Berichte",
    personnel_planning: "Personalplanung",
    time_tracking: "Zeiterfassung",
    document_design: "PDF-Vorlagen",
    day_submissions: "Tagesmeldungen",
    suppliers: "Lieferanten",
    supplier_insights: "Lieferanten-Auswertungen",
    advanced_analytics: "Erweiterte Analysen",
    api_access: "API-Zugang",
  },
  // Kurze „Showcase“-Texte für die Info-Buttons (ⓘ): je Funktionspaket, Tarif sowie Plätze/Zusatzfunktionen.
  showcase: {
    core: {
      desc: "Die täglichen Grundlagen, auf denen jeder Tarif aufbaut: Kunden, Projekte und Ihr Team an einem Ort.",
      p1: "Kunden, Mitarbeiter und Maschinen verwalten",
      p2: "Ein gemeinsamer Arbeitsbereich für Ihr Team",
      p3: "In Minuten eingerichtet, ohne Schulung",
    },
    project_management: {
      desc: "Projekte planen, verfolgen und abschließen, vom Angebot bis zur Übergabe.",
      p1: "Arbeit in Projekte und Aufgaben gliedern",
      p2: "Fortschritt, Kosten und Termine im Blick",
      p3: "Dokumente und Notizen je Projekt",
    },
    invoicing: {
      desc: "Erfasste Arbeit und Material in saubere, professionelle Rechnungen umwandeln.",
      p1: "Rechnungen aus Stunden- und Materialberichten",
      p2: "Erst als Entwurf prüfen, dann abrechnen",
      p3: "Als PDF exportieren, direkt versandfertig",
    },
    reporting: {
      desc: "Mit fertigen Betriebsberichten sehen, wohin Zeit und Geld fließen.",
      p1: "[[hwr.pl]] und [[cr.pl]]",
      p2: "Nach Projekt, Mitarbeiter oder Zeitraum filtern",
      p3: "Ergebnisse für die Buchhaltung exportieren",
    },
    personnel_planning: {
      desc: "Die richtigen Personen den richtigen Aufträgen zuweisen und Konflikte vermeiden.",
      p1: "Visuelle Planungstafel per Drag-and-drop",
      p2: "Konflikte und Lücken auf einen Blick",
      p3: "Den Plan mit dem Team teilen",
    },
    time_tracking: {
      desc: "Arbeitszeitmodelle anlegen, Zeiten erfassen und sehen, was das Personal je Projekt kostet.",
      p1: "Vollzeit, Teilzeit und Schicht als eigene Modelle",
      p2: "Beginn, Ende und Pausen, auch vom Polier fürs ganze Team",
      p3: "Pausen nach ArbZG automatisch abgezogen",
    },
    document_design: {
      desc: "[[cr.pl]], Abrechnungen und alle anderen PDF-Dokumente im Erscheinungsbild Ihrer Firma.",
      p1: "Eigenes Briefpapier mit Logo, Farben, Schrift und Fußzeile",
      p2: "Je Dokument festlegen, was es zeigt und in welcher Reihenfolge",
      p3: "Mehrere Vorlagen, je Projekt wählbar",
    },
    supplier_insights: {
      desc: "Sehen, was Maschinen und Material bei Ihren Lieferanten kosten, wie sich die Preise entwickeln und wer am günstigsten liefert.",
      p1: "Preisverlauf je Maschine und Material",
      p2: "Lieferantenvergleich mit der Ersparnis je Artikel",
      p3: "Preislisten als CSV oder Excel importieren",
    },
    advanced_analytics: {
      desc: "Mehr als Standardberichte: tiefere Einblicke in Ihren Betrieb.",
      p1: "Trends über Projekte und Zeiträume",
      p2: "Kennzahlen zu Rentabilität und Auslastung",
      p3: "Dashboards in Echtzeit",
    },
    api_access: {
      desc: "Lewara über eine sichere REST-API mit Ihren anderen Tools verbinden.",
      p1: "Daten programmgesteuert lesen und schreiben",
      p2: "Exporte und Integrationen automatisieren",
      p3: "API-Schlüssel mit eigenem Umfang",
    },
    basic: {
      desc: "Alles, was ein kleines Team für die tägliche Arbeit in Lewara braucht.",
      p1: "Kern-Arbeitsbereich für Kunden und Projekte",
      p2: "Ideal für den Einstieg",
      p3: "Jederzeit erweiterbar",
    },
    pro: {
      desc: "Mehr Leistung für wachsende Teams: Planung, Abrechnung und Berichte inklusive.",
      p1: "Alles aus Basic, plus Planung & Abrechnung",
      p2: "Für größere, aktivere Teams",
      p3: "Unsere beliebteste Wahl",
    },
    enterprise: {
      desc: "Der volle Funktionsumfang mit erweiterten Analysen und API-Zugang.",
      p1: "Alle Funktionen von Lewara",
      p2: "Erweiterte Analysen und API-Zugang",
      p3: "Bestes Preis-Leistungs-Verhältnis bei Skalierung",
    },
    seats: {
      desc: "Ein Platz ist für jemanden, der sich bei Lewara anmeldet, nicht für jeden im Team. Sie können deutlich mehr Mitarbeiter im System führen, als Sie Plätze haben; nur wer sich tatsächlich anmeldet, braucht einen.",
      p1: "Plätze sind nur für Personen, die sich anmelden",
      p2: "Deutlich mehr Mitarbeiter als Plätze möglich, der Rest meldet sich einfach nicht an",
      p3: "Plätze jederzeit hinzufügen oder entfernen; berechnet werden die Plätze, die Sie behalten",
    },
    addons: {
      desc: "Optionale Funktionspakete für jeden Tarif. Zahlen Sie nur, was Sie brauchen.",
      p1: "Funktionen ohne Tarifwechsel hinzufügen",
      p2: "Jederzeit ein- oder ausschalten",
      p3: "Einige sind in höheren Tarifen enthalten",
    },
  },
  addon: {
    label: "Zusätzliche Funktionen",
  },
  seats: {
    label: "Benutzerplätze",
    hint: "Pro Web-Benutzer wird ein Platz benötigt.",
    used: "Belegt",
    purchased: "Gekauft",
    buy_more: "Weitere Plätze kaufen",
  },
  price: {
    summary_hint: "Die genauen Preise werden im Zahlungsschritt angezeigt.",
    per_seat: "pro Platz",
    per_month: "pro Monat",
    total: "Gesamt",
  },
  payment: {
    continue: "Weiter zur Zahlung",
    back: "Zurück",
    confirm: "Zahlung bestätigen",
    processing: "Zahlung wird verarbeitet …",
    success: "Zahlung erfolgreich",
    error: "Die Zahlung konnte nicht verarbeitet werden.",
    pending: "Ihre Zahlung wird noch verarbeitet. Bitte versuchen Sie es in Kürze erneut.",
    declined:
      "Ihre Karte wurde abgelehnt, die Planänderung wurde nicht übernommen. Bitte aktualisieren Sie Ihre Zahlungsmethode und versuchen Sie es erneut.",
  },
  // Stripe-Checkout-Rückkehrseite (nur bei Zahlungsarten mit Weiterleitung / SCA).
  return: {
    title: "Wird abgeschlossen",
    subtitle: "Ihre Zahlung wird mit Stripe bestätigt.",
    processing: "Ihre Zahlung wird bestätigt …",
    pending: "Ihre Zahlung wird noch verarbeitet. Das kann einen Moment dauern. Sie müssen nicht erneut bezahlen.",
  },
  grace: {
    banner:
      "Ihre Zahlung ist fehlgeschlagen. Bitte aktualisieren Sie Ihre Zahlungsdaten. Noch {days} Tag(e) bis zur Sperrung.",
    action: "Zum Abonnement",
  },
  // Zustände des Abo-Indikators (Navigationsleiste, Abo-Einstellungen). Bewusst kurz: der Indikator
  // steht in einer 256px breiten Leiste. Erklärungen gehören in die `_detail`-Zeilen.
  status: {
    active: "Aktiv",
    // Gekündigt, läuft aber noch bis zum Periodenende – "Gekündigt" allein läse sich wie "kein Zugriff".
    canceling: "Läuft aus",
    canceling_detail: "Endet am {date}",
    grace: "Zahlung fällig",
    grace_detail: "Noch {days} Tag(e) Zugriff",
    // Abo angelegt, erste Zahlung noch nicht bestätigt.
    pending: "Zahlung ausstehend",
    // Zeitraum abgelaufen, nachdem gekündigt wurde – anders als eine Sperre wegen Zahlungsausfall.
    expired: "Beendet",
    locked: "Gesperrt",
    exempt: "Kostenfrei",
    none: "Kein Abonnement",
    unknown: "Unbekannt",
  },
  plans: {
    eyebrow: "Preise",
    title: "Tarife & Preise",
    subtitle:
      "Vergleichen Sie die Tarife und wählen Sie den passenden für Ihr Team. Plätze und Zusatzfunktionen jederzeit anpassbar.",
    choose: "Tarif wählen",
    change: "Tarif ändern",
    get_started: "Loslegen",
    current: "Aktuell",
    current_plan: "Aktueller Tarif",
    login: "Anmelden",
    signup: "Registrieren",
    back_to_app: "Zurück zur App",
    home: "Zur Lewara-Startseite",
    interval_month: "/Monat",
    interval_year: "/Jahr",
    cadence: "Abrechnungszeitraum",
    cadence_month: "Monatlich",
    cadence_year: "Jährlich",
    save_percent: "{percent}% sparen",
    per_month_billed_yearly: "≈ {price}/Monat, jährlich abgerechnet",
    for_seats_one: "für {count} Benutzer",
    for_seats_other: "für {count} Benutzer",
    team_size: "Teamgröße",
    per_user_short: "/Benutzer",
    custom: "Individuell",
    most_popular: "Beliebtester Tarif",
    addon_optional: "Optionale Zusatzfunktion",
    addon_included_in: "In {plans} enthalten",
    everything_in: "Alles aus {plan}",
    addon_add: "Hinzufügen",
    addon_added: "Hinzugefügt",
    addon_included: "Enthalten",
    addon_in_plan: "In Ihrem Tarif enthalten",
    trust_secure: "Sichere Zahlung über Stripe",
    trust_cancel: "Jederzeit kündbar",
    trust_support: "Freundlicher Support",
  },
  summary: {
    title: "Bestellübersicht",
    total: "Gesamt",
    base_plan: "Grundtarif",
    seats_line: "Plätze · {count} × {price}",
    cadence_month: "Monatlich abgerechnet",
    cadence_year: "Jährlich abgerechnet",
    discount_line: "Jahresrabatt",
    change: "Ändern",
    note: "Zahlungsdaten werden an der Kasse erfasst.",
  },
  invoices: {
    title: "Rechnungen",
    empty: "Noch keine Rechnungen.",
    date: "Datum",
    number: "Nummer",
    amount: "Betrag",
    status: "Status",
    document: "Beleg",
    download: "Herunterladen",
    view: "Ansehen",
    status_paid: "Bezahlt",
    status_open: "Offen",
    status_void: "Storniert",
    status_draft: "Entwurf",
    status_uncollectible: "Uneinbringlich",
  },
  settings: {
    // Nicht "Abrechnung": dieser Tab ist das SaaS-Abonnement (Tarif, Plätze, Zahlungsmethode).
    // "Abrechnung" gehört zum Stundenlohn-Assistenten in der Navigation (`nav.invoice`).
    title: "Abonnement",
    // Heißt bewusst nicht mehr "Abonnement" — das ist jetzt der Tab-Titel direkt darüber.
    plan_section: "Tarif",
    current_plan: "Aktueller Tarif",
    addons: "Zusätzliche Funktionen",
    seats: "Benutzerplätze",
    period_end: "Aktueller Zeitraum endet am",
    billing_cycle: "Abrechnungszeitraum",
    card: "Zahlungsmethode",
    change_plan: "Tarif ändern",
    update_card: "Zahlungsmethode aktualisieren",
    card_unavailable:
      "Die Aktualisierung der Zahlungsmethode ist derzeit nicht verfügbar. Bitte versuchen Sie es später erneut.",
    manage: "Abonnement verwalten",
    // Steht anstelle der Ändern-/Kündigen-Aktionen für Leser mit VIEW_BILLING, aber ohne MANAGE_BILLING.
    manage_denied: "Nur berechtigte Personen können dieses Abonnement ändern oder kündigen.",
    back: "Zurück zum Abonnement",
    change_plan_subtitle: "Tarif wechseln oder Plätze und Zusatzfunktionen anpassen. Änderungen gelten sofort.",
    interval_switch_note:
      "Der Wechsel des Abrechnungszeitraums gilt sofort. Die Differenz für den Rest des laufenden Zeitraums wird anteilig berechnet und mit Ihrer nächsten Rechnung verrechnet.",
    update_card_subtitle: "Aktualisieren Sie die Karte, die für Ihr Abonnement belastet wird.",
    card_saved: "Zahlungsmethode aktualisiert.",
    cancel: "Abonnement kündigen",
    cancel_confirm_title: "Abonnement kündigen?",
    cancel_confirm_text: "Ihr Abonnement bleibt bis zum Ende des aktuellen Zeitraums aktiv.",
    exempt_notice: "Ihr Konto ist von der Abrechnung ausgenommen.",
    cancels_at_period_end: "Wird zum Ende des Zeitraums gekündigt.",
  },
  seatDialog: {
    title: "Weitere Plätze hinzufügen",
    description: "Sie haben Ihr Platzlimit erreicht. Kaufen Sie weitere Plätze, um diesen Benutzer anzulegen.",
    current: "Aktuell {current} von {max} Plätzen belegt.",
    confirm: "Plätze kaufen",
  },
  // Zusatzmodul-Hinweis beim Aufruf einer nicht gebuchten Funktion (FeatureLockedView).
  locked: {
    eyebrow: "Zusatzmodul",
    title: "{feature} ist nicht in Ihrem Tarif enthalten",
    subtitle: "Fügen Sie die Funktion Ihrem Abonnement hinzu, um sie sofort zu nutzen.",
    add: "Zum Tarif hinzufügen",
    upgrade: "Tarif hochstufen",
    back: "Zurück zum Dashboard",
    note: "Sie können alles prüfen, bevor Sie bestätigen.",
    // For a feature-set that is not on sale yet (neither an add-on nor part of a plan). The name goes last:
    // "Tagesmeldungen" and "PDF-Vorlagen" are plurals, which an "ist" after them would get wrong.
    unavailable_title: "Noch nicht verfügbar: {feature}",
    unavailable_text: "Wir führen diese Funktion gerade schrittweise ein. Buchen lässt sie sich noch nicht.",
    unavailable_contact: "Sie möchten sie schon jetzt nutzen? Schreiben Sie uns:",
  },
}
